const ta = {
    nav: {
      home: "முகப்பு",
      browse: "திருமணங்களை உலாவு",
      dashboard: "டேஷ்போர்டு",
      messages: "செய்திகள்",
      profile: "சுயவிவரம்",
      login: "உள்நுழைக",
      register: "பதிவு",
      logout: "வெளியேறு",
      admin: "நிர்வாகி",
      faq: "தொடர்பான கேள்விகள்",
      about: "பற்றி",
      contact: "தொடர்பு",
      pricing: "�ிலை",
      howItWorks: "இது எவ்வாறு செயல்படுகிறது",
    },
    auth: {
      login: {
        title: "மீண்டும் வரவேற்கிறோம்",
        email: "மின்னஞ்சல்",
        password: "கடவுச்சொல்",
        button: "உள்நுழைக",
        noAccount: "கணக்கு இல்லையா?",
        register: "இப்போது பதிவு செய்யவும்",
      },
      register: {
        title: "கணக்கு உருவாக்க",
        name: "முழு பெயர்",
        email: "மின்னஞ்சல்",
        password: "கடவுச்சொல்",
        role: "எனக்கு வேண்டியது...",
        roleHost: "திருமணம் ஏற்பாடு செய்",
        roleGuest: "திருமணங்களில் பங்கேற்",
        terms: "நிபந்தனைகள் மற்றும் தனியுரிமைக் கொள்கையை ஏற்கிறேன்",
        button: "பதிவு",
        hasAccount: "ஏற்கனவே கணக்கு இருக்கிறதா?",
        login: "இப்போது உள்நுழைக",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "ஏற்றுகிறது...",
      error: "பிழை ஏற்பட்டது",
      success: "வெற்றி",
      save: "சேமி",
      cancel: "ரத்து செய்",
      delete: "நீக்கு",
      edit: "திருத்து",
      back: "பின்",
      next: "அடுத்து",
      language: "மொழி",
      currency: "நாணயம்",
      search: "தேடல்",
      filter: "வடிகட்டி",
      all: "எல்லாம்",
      none: "எதுவும் இல்லை",
      yes: "ஆம்",
      no: "இல்லை",
    },
    footer: {
      about: "பற்றி",
      privacy: "தனியுரிமை",
      terms: "ஷரத்துகள்",
      contact: "தொடர்பு",
      copyright: "© 2024 WEDVAYA. உரிமைகள் அனைத்தும் பாதுகாக்கப்பட்டவை.",
    },
  };

export default ta;
